<template>
  <div>
    <div class="event-background">
      <link
        href="https://fonts.googleapis.com/css?family=Maven+Pro:400,500,700,900&display=swap"
        rel="stylesheet"
      />
      <div class="background-blur">
        <img v-if="event.posterMode === 'IMAGE'" :src="event.posterUrl" />
        <img
          v-if="event.posterMode === 'VIDEO_EMBED'"
          :src="this.parseThumbnail"
        />
      </div>
      <div class="event-container">
        <div class="event-header" :class="{ noposter: !event.posterUrl }">
          <div v-if="event.posterUrl" class="header-poster">
            <div v-if="event.posterMode === 'IMAGE'" class="poster-image">
              <img :src="event.posterUrl" />
            </div>

            <div class="video-embed" v-if="event.posterMode === 'VIDEO_EMBED'">
              <iframe
                width="100%"
                height="100%"
                :src="this.parseVideo"
                frameborder="0"
                webkitAllowFullScreen
                mozallowfullscreen
                allowfullscreen
              ></iframe>
            </div>
          </div>

          <div class="meta-description">
            <p>{{ event.organization.name }} Presents</p>
            <h2>{{ event.name }}</h2>
            <event-date
              :startDate="event.eventDate"
              :endDate="event.eventEnd"
              :timezone="event.eventTimezone"
              :theme="'dark'"
              :enable-countdown="true"
            />
          </div>
        </div>

        <div class="event-actionbar">
          <div v-if="event.buttonText && !isEventInactive" class="tickets-container">
            <button
              type="button"
              class="btn-tickets"
              @click="clickTickets"
              :style="{
                color: event.buttonTextColor,
                backgroundColor: event.buttonBgColor
              }"
            >
              {{ event.buttonText }}
            </button>
            <p v-if="event.min.length > 0">
              {{ formatPrice(event.min) }}
              <span v-if="event.max > event.min">
                - {{ formatPrice(event.max) }}</span
              >
            </p>
          </div>

          <div v-if="event.embedId && !isEventInactive">
            <button
              type="button"
              class="btn-donate"
              v-b-modal.donation-modal
            >
              Donate
            </button>
          </div>
        </div>

        <div class="event-content">
          <div class="event-sidebar">
            <h3 class="section-title">Location</h3>
            <strong>{{ event.venueName }}</strong>
            <br />
            <event-address
              :street="event.streetAddress"
              :streetTwo="event.streetAddress2"
              :city="event.city"
              :state="event.state"
              :zip="event.zip"
              :country="event.country"
            />

            <button
              type="button"
              class="btn-contact btn-link"
              :disabled="isEventInactive"
              v-b-modal.event-contact-promoter-modal
              :style="{
                color: event.buttonBgColor
              }"
            >
              <i class="fa fa-envelope" /> Contact Promoter
            </button>
            <br />
            <map-component
              class="event-map"
              :address="event.address"
              v-if="event.address"
            />
            <br />
          </div>

          <div class="event-description">
            <h3 class="section-title">Event Description</h3>
            <div ref="summaryContent">
              {{ renderHTMLContent("summaryContent", event.summary) }}
            </div>
            <div ref="descriptionContent">
              {{ renderHTMLContent("descriptionContent", event.description) }}
            </div>

            <div
              class="content-section"
              v-if="this.event.terms && this.event.terms.length > 0"
            >
              <h4 class="section-title">Terms &amp; Conditions</h4>
              <div ref="termsContent">
                {{ renderHTMLContent("termsContent", event.terms) }}
              </div>
            </div>

            <div
              v-if="tiers !== null && tiers !== undefined && tiers.length > 0"
            >
              <div
                class="content-section"
                v-if="
                  tiers[0].sponsors.length > 0 ||
                    tiers[1].sponsors.length > 0 ||
                    tiers[2].sponsors.length > 0
                "
              >
                <event-sponsors :tiers="tiers" />
              </div>
            </div>
          </div>
        </div>
        <div class="event-footer">
          <div class="footer-text">
            <strong>{{ event.name }}</strong>
            <event-date
              :startDate="event.eventDate"
              :endDate="event.eventEnd"
              :timezone="event.eventTimezone"
              :theme="'light'"
            />
            <p v-if="event.min.length > 0">
              {{ formatPrice(event.min) }}
              <span v-if="event.max > event.min">
                - {{ formatPrice(event.max) }}</span
              >
            </p>
            <button
              type="button"
              class="btn-link"
              :disabled="isEventInactive"
              v-b-modal.event-contact-promoter-modal
              :style="{
                color: event.buttonBgColor
              }"
            >
              <i class="fa fa-envelope" />
              Contact Promoter
            </button>
          </div>

          <img class="footer-logo" :src="event.footerLogoImageUrl" />
        </div>
        <event-contact-promoter-modal-component
          id="event-contact-promoter-modal"
          :eventId="event.id"
        />

        <b-modal
          body-class="p-0"
          id="register-event-tickets-modal"
          ref="modal"
          size="xl"
          centered
          tall
          hide-footer
          hide-header
          no-close-on-backdrop
          v-scroll-lock="true"
        >
          <ticket-checkout :posterUrl="``" @close="closeCheckout" isPublicApp />
        </b-modal>

        <b-modal
          v-if="event.embedId"
          id="donation-modal"
          title="Donate Now"
          size="lg"
          centered
          tall
          hide-footer
          hide-header
        >
          <donation-embed :embedId="event.embed && event.embed.id" :embedType="event.embed && event.embed.type" :eventId="event.id" />
        </b-modal>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import EventContactPromoterModalComponent from "@/components/Events/EventContactPromoterModalComponent.vue";
import TypeUtils from "@/api/util/TypeUtils";
import DonationEmbed from "@/components/DonationEmbed.vue";
import MapComponent from "@/components/Widgets/MapComponent.vue";
import FormatUtils from "@/api/util/FormatUtils";
import EventDate from "@/components/EventDate.vue";
import EventSponsors from "@/components/EventSponsors.vue";
import TicketCheckout from "@/components/TicketCheckout.vue";
import EventAddress from "@/components/EventAddress.vue"

export default Vue.extend({
  name: "template-two",
  props: ["event", "tiers", "isEventInactive", "posterVideoURL"],
  components: {
    EventContactPromoterModalComponent,
    DonationEmbed,
    MapComponent,
    EventDate,
    EventSponsors,
    TicketCheckout,
    EventAddress
  },
  data() {
    return {
      vimeoThumbnail: ""
    };
  },

  created() {
    this.fetchVimeoThumbnail();
  },

  computed: {
    parseVideo: function() {
      return FormatUtils.parseVideoURL(this.event.posterUrl);
    },

    parseThumbnail: function() {
      if (FormatUtils.parseVideoType(this.event.posterUrl) === "youtube")
        return `https://img.youtube.com/vi/${FormatUtils.parseYoutubeURL(
          this.event.posterUrl
        )}/0.jpg`;
      if (FormatUtils.parseVideoType(this.event.posterUrl) === "vimeo") {
        return this.vimeoThumbnail;
      }
    }
  },

  methods: {
    renderHTMLContent(elementRef, contentString) {
      this.$nextTick(function() {
        if (!this.$refs[elementRef]) return "";

        this.$refs[elementRef].innerHTML = contentString;
        const links = this.$refs[elementRef].getElementsByTagName("a");

        for (let i = 0; i < links.length; i++) {
          links[i].setAttribute("style", `color: ${this.event.buttonBgColor}`);
        }
      });
    },

    fetchVimeoThumbnail() {
      axios
        .get(
          `https://vimeo.com/api/v2/video/${FormatUtils.parseVimeoURL(
            this.event.posterUrl
          )}.json`
        )
        .then(response => {
          this.vimeoThumbnail = response.data[0].thumbnail_large;
        });
    },

    closeCheckout() {
      this.$refs.modal.hide();
    },

    formatPrice(price) {
      return TypeUtils.toFloat(price) === 0
        ? "Free"
        : FormatUtils.formatCurrency(price, this.event.currencyCode);
    },

    clickTickets() {
      this.$bvModal.show("register-event-tickets-modal");
    }
  }
});
</script>
<style scoped>
.event-background {
  background-color: #f0eff0;
  -webkit-animation: fadein 2s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadein 2s; /* Firefox < 16 */
  -ms-animation: fadein 2s; /* Internet Explorer */
  -o-animation: fadein 2s; /* Opera < 12.1 */
  animation: fadein 2s;
  min-height: 100vh;
  padding: 1em 0;
}
.event-container {
  max-width: 1080px;
  width: 100%;
  margin: 1em auto;
  padding: 0;
  border-radius: 3px;
  z-index: 2;
  position: relative;
  font-family: "Maven Pro", sans-serif;
  line-height: 1.4;
  overflow: hidden;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
}

.event-description p {
  line-height: 1.4;
  font-weight: 400;
  margin-bottom: 0.5em !important;
}

.event-header {
  display: flex;
}

.header-poster {
  width: 66.6666666667%;
  position: relative;
  overflow: hidden;
}

.poster-image img {
  background-size: cover;
  width: 720px;
  height: 405px;
}

.video-embed {
  overflow: hidden;
  position: relative;
  width: 100%;
}

.video-embed::after {
  padding-top: 56.25%;
  display: block;
  content: "";
}

.video-embed iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.video-embed iframe >>> #player {
  max-width: 100% !important;
}

.meta-description {
  width: 33.3333333333%;
  background: #010007c2;
  color: #fff;
  padding: 2em;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.meta-description .event-date {
  margin-top: 2em;
  font-weight: bold;
}

.meta-description p {
  margin-bottom: 0;
}

.event-actionbar {
  display: flex;
  justify-content: space-between;
  background: #fff;
  padding: 1em;
  border-bottom: 1px solid #dbdae3;
}

.event-actionbar .btn-tickets {
  background: #0336ff;
  border-radius: 2px;
  border: 0;
  padding: 5px 15px;
  font-size: 16px;
  display: inline-block;
}

.event-actionbar .btn-donate {
  background: #3578e5;
  color: #fff;
  border-radius: 2px;
  border: 0;
  padding: 5px 15px;
  font-size: 16px;
  display: inline-block;
}

.tickets-container p {
  font-weight: 500;
  display: inline-block;
  margin-left: 10px;
}

.btn-link {
  background: none;
  border: 0;
  color: #0336ff;
  font-size: 16px;
  margin: 0.5rem 0;
  padding: 0;
}

.btn-link:hover {
  text-decoration: none;
}

.event-content {
  display: flex;
  background: #fff;
  padding-top: 2em;
  padding-bottom: 5em;
}

.section-title {
  text-transform: uppercase;
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 1.5rem;
}

.content-section >>> .section-title {
  text-transform: uppercase;
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 1.5rem;
}

.event-description {
  max-width: 70%;
  width: 100%;
  padding: 1em;
  background: #fff;
  overflow: hidden;
}

.event-description img {
  max-width: 100% !important;
}

.event-container .image img {
  max-width: 100% !important;
}

.event-sidebar {
  background: #fff;
  margin-left: 0;
  padding: 1em;
  width: 30%;
}

.event-sidebar p {
  margin-top: 0.5rem;
  margin-bottom: 0;
}

.event-map {
  margin: 1rem 0;
}

.background-blur {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
  height: 48.3vh;
  min-height: 500px;
  max-height: inherit;
  overflow: hidden;
}

.background-blur img {
  transform: translate(-50%, -50%);
  -webkit-filter: blur(50px) brightness(0.9);
  -ms-filter: blur(50px) brightness(0.9);
  filter: blur(50px) brightness(0.9);
  display: inline-block;
  width: 200%;
  position: relative;
  top: 50%;
  left: 50%;
}

.content-section {
  border-top: 2px solid #f0eff0;
  padding-top: 1.5em;
}

.event-footer {
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  float: right;
  clear: both;
  padding: 1em;
  border-top: 1px solid #dbdae3;
}

.event-footer .footer-text {
  padding-top: 1.5em;
}

.event-footer .footer-text p {
  color: #212529;
  margin-bottom: 0;
}

.event-footer .footer-logo {
  max-width: 130px;
  max-height: 130px;
}

.noposter {
  height: inherit;
}

.noposter .meta-description {
  width: 100%;
  position: relative;
  display: block;
}

.noposter .meta-description h2 {
  max-width: 70%;
}

.noposter .meta-description p {
  max-width: 70%;
}

.noposter >>> .event-date {
  position: absolute;
  right: 1em;
  top: 1em;
}

/************************
* Responsive Breakpoints
*************************/
@media (max-width: 1080px) {
  .event-background {
    padding: 0;
  }

  .event-container {
    padding: 0;
    margin: 0;
    border-radius: 0;
  }

  .background-blur {
    display: none;
  }

  .event-header {
    height: 340px;
  }

  .poster-image img {
    width: 100%;
    height: auto;
  }
}

@media (max-width: 960px) {
  .event-header {
    height: inherit;
  }
  .event-content {
    flex-direction: column;
  }

  .event-sidebar {
    order: 1;
    width: 100%;
  }

  .event-description {
    order: 2;
    width: 100%;
    max-width: 100%;
  }

  .event-header {
    height: 290px;
  }
}

@media (max-width: 760px) {
  .event-header {
    height: auto;
  }

  .meta-description {
    width: 50%;
  }

  .meta-description .event-date {
    margin-top: 0;
  }

  .background-blur {
    display: none;
  }

  .video-embed iframe {
    background: #010007c2;
  }

  .noposter .meta-description .event-date {
    position: relative;
    top: inherit;
    right: inherit;
    margin-top: 2em;
  }
}

@media (max-width: 720px) {
  .event-header {
    display: block;
  }

  .header-poster {
    width: 100%;
  }

  .poster-image {
    width: 100%;
  }

  .meta-description {
    width: 100%;
  }
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Firefox < 16 */
@-moz-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Internet Explorer */
@-ms-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
